import { render, staticRenderFns } from "./SignupPackagesPayments.vue?vue&type=template&id=cbd06c76"
import script from "./SignupPackagesPayments.vue?vue&type=script&lang=js"
export * from "./SignupPackagesPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports